import { createSlice } from "@reduxjs/toolkit";
import { fetchAddPracticeInfoProviders, fetchPracticeInfoProviders, fetchReasonCodeActive, fetchSearchedProviders, fetchUpdateStatus } from "./ProviderDetailsActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";


const practiceInfoProviders = createSlice({
    name: "practiceInfoProviders",
    initialState: {
        isProvidersDataLoading: false,
        practiceInfoProvidersDetails: {},
        providersDetailsError: null,
        providersDetailsErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPracticeInfoProviders.pending, (state) => {
                state.isProvidersDataLoading = true;
                state.providersDetailsError = null;
            })
            .addCase(fetchPracticeInfoProviders.fulfilled, (state, action) => {
                state.isProvidersDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.providersDetailsError = false;
                        state.practiceInfoProvidersDetails = {};
                    }
                    else {
                        state.providersDetailsError = true;
                        state.providersDetailsErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.providersDetailsError = false;
                    state.practiceInfoProvidersDetails = action.payload.data.data.accessPointBriefResponseDTO;
                }
            })
            .addCase(fetchPracticeInfoProviders.rejected, (state, action) => {
                state.isProvidersDataLoading = false;
                state.providersDetailsError = action.error.message;
            });
    },
});


const searchProviders = createSlice({
    name: "searchProviders",
    initialState: {
        isSearchProvidersDataLoading: false,
        searchProvidersData: {},
        searchProvidersError: null,
        searchProvidersErrorMsg: ""
    },
    reducers: {
        clearSearchProvidersData: (state) => {
            state.searchProvidersData = {};
            state.searchProvidersError = null;
            state.searchProvidersErrorMsg = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSearchedProviders.pending, (state) => {
                state.isSearchProvidersDataLoading = true;
                state.searchProvidersError = null;
            })
            .addCase(fetchSearchedProviders.fulfilled, (state, action) => {
                state.isSearchProvidersDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.searchProvidersError = false;
                        state.searchProvidersData = {};
                    }
                    else {
                        state.searchProvidersError = true;
                        state.searchProvidersErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.searchProvidersError = false;
                    state.searchProvidersData = action.payload.data.data.providerResponseDTO.items;
                }
            })
            .addCase(fetchSearchedProviders.rejected, (state, action) => {
                state.isSearchProvidersDataLoading = false;
                state.searchProvidersError = action.error.message;
            });
    },
});



const addPracticeInfoProviders = createSlice({
    name: "addPracticeInfoProviders",
    initialState: {
        isAddPracticeInfoProvidersDataLoading: false,
        addPracticeInfoProvidersData: [],
        addPracticeInfoProvidersError: null,
        addPracticeInfoProvidersErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAddPracticeInfoProviders.pending, (state) => {
                state.isAddPracticeInfoProvidersDataLoading = true;
                state.addPracticeInfoProvidersError = null;
            })
            .addCase(fetchAddPracticeInfoProviders.fulfilled, (state, action) => {
                state.isAddPracticeInfoProvidersDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.addPracticeInfoProvidersError = false;
                        state.addPracticeInfoProvidersData = [];
                    }
                    else {
                        state.addPracticeInfoProvidersError = true;
                        state.addPracticeInfoProvidersErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.addPracticeInfoProvidersError = false;
                    state.addPracticeInfoProvidersData = action.payload.data.data.accessPointExtendedResponseDTO;
                }
            })
            .addCase(fetchAddPracticeInfoProviders.rejected, (state, action) => {
                state.isAddPracticeInfoProvidersDataLoading = false;
                state.addPracticeInfoProvidersError = action.error.message;
            });
    },
});



const fetchReasonCodeActiveStatus = createSlice({
    name: "fetchReasonCodeActiveStatus",
    initialState: {
        isReasonCodeDataLoading: false,
        reasonCodeActive: [],
        reasonCodeError: null,
        reasonCodeErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReasonCodeActive.pending, (state) => {
                state.isReasonCodeDataLoading = true;
                state.reasonCodeError = null;
            })
            .addCase(fetchReasonCodeActive.fulfilled, (state, action) => {
                state.isReasonCodeDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.reasonCodeError = false;
                        state.reasonCodeActive = [];
                    }
                    else {
                        state.reasonCodeError = true;
                        state.reasonCodeErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.reasonCodeError = false;
                    console.log("action.payload : ",action.payload);
                    
                    state.reasonCodeActive = action.payload.data.data.reasonCodeResponseDTO;
                }
            })
            .addCase(fetchReasonCodeActive.rejected, (state, action) => {
                state.isReasonCodeDataLoading = false;
                state.reasonCodeError = action.error.message;
            })
    },
});



const fetchStatusUpdate = createSlice({
    name: "fetchStatusUpdate",
    initialState: {
        isStatusDataLoading: false,
        providersStatus: [],
        statusError: null,
        statusErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUpdateStatus.pending, (state) => {
                state.isStatusDataLoading = true;
                state.statusError = null;
            })
            .addCase(fetchUpdateStatus.fulfilled, (state, action) => {
                state.isStatusDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.statusError = false;
                        state.providersStatus = [];
                    }
                    else {
                        state.statusError = true;
                        state.statusErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.statusError = false;
                    state.providersStatus = action.payload.data.data;
                }
            })
            .addCase(fetchUpdateStatus.rejected, (state, action) => {
                state.isStatusDataLoading = false;
                state.statusError = action.error.message;
            })
    },
});



export const { updateProvidersDetails } = practiceInfoProviders.actions;
export const practiceInfoProvidersReducer = practiceInfoProviders.reducer;
export const searchProvidersReducer = searchProviders.reducer;
export const {clearSearchProvidersData} = searchProviders.actions;
export const addPracticeInfoProvidersReducer = addPracticeInfoProviders.reducer;
export const fetchReasonCodeActiveStatusReducer = fetchReasonCodeActiveStatus.reducer;
export const fetchStatusUpdateReducer = fetchStatusUpdate.reducer;